/**
 * @summary - Component that Provides User Registration List
 * @author Purushothaman T
 */
import { Box, Button, Dialog, Stack } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import CreateNewBtn from "../commoncomponents/CreateNewBtn";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import CustomDialog from "../commoncomponents/CustomDialog";
import { dialogContent } from "../../utility/message";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import CustomTooltip from "../commoncomponents/CustomTooltip";
import ViewListIcon from '@mui/icons-material/ViewList';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";



const List = () => {
  const [rowData, setRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const [gridApiHospitalList, setGridApiHospitalList] = useState({});
  const [contentDialog, setContentDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [data, setData] = useState("")
  const [openDialog, setOpenDialog] = useState(false)
  const [ViewlistopenDialog, setViewlistopenDialog] = useState(false)
  const [listrowData, setListRowData] = useState([])
  const [username, setUsername] = useState("")

  const navigate = useNavigate(); 

  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    setListRowData([]);
    setRowData([]);
    setIsLoading(true);
    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterList`,
        config
      );

      setRowData(response.data.map((data) => {
        return {
          ...data,
          isactive: data?.isactive ? "Active" : "Inactive"
        }
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const colHospitalListDefs = [
    { field: "username", headerName: "User Name" },
    { field: "companyName", headerName: "Company Name" },
    { field: "facilityName", headerName: "Location Name" },
    { field: "facilitycode", headerName: "Location Code" },

  ];

  const colDefs = [
    { field: "userName", headerName: "User Name" },
    { field: "firstName", headerName: "First Name" },
    { field: "lastName", headerName: "Last Name" },
    { field: "userType", headerName: "User Type" },
    { field: "staffStatus", headerName: "Staff Status" },
    {
      field: "isactive",
      headerName: "Status",
      cellRenderer: (params) => {
        if (params.value === "Active") {
          return <SuccessChips label={params.value} />;
        } else {
          return <ErrorChips label={params.value} />;
        }
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      cellRenderer: (params) => {
        return (
          <>
            <CustomTooltip title="Edit">
              <IconButton
                onClick={() => handleEdit(params.data)}
                data-testid="edit-button"
              >
                <EditIcon />
              </IconButton>
            </CustomTooltip>

            <CustomTooltip title="View">
              <IconButton
                onClick={() => handleView(params.data)}
                data-testid="view-button"
              >
                <VisibilityIcon />
              </IconButton>
            </CustomTooltip>
            <CustomTooltip title="Delete">
              <IconButton
                onClick={() => handleDelete(params.data)}
                data-testid="delete-button"
              >
                <DeleteIcon />
              </IconButton>
            </CustomTooltip>
            <CustomTooltip title="View-List">
              <IconButton
                onClick={() => handleViewList(params.data)}
                data-testid="view-button"
              >
                <ViewListIcon />
              </IconButton>
            </CustomTooltip>
          </>
        );
      },
    }
  ]

  const handleEdit = (data) => {
    navigate("/user/edit", {
      state: {
        id: data?.userId,
        companyId: data?.companyId,
        userTypeId: data?.userTypeId,
        isEditMode: true,
      },
    });
  };

  const handleView = (data) => {
    navigate("/user/view", {
      state: {
        id: data?.userId,
        companyId: data?.companyId,
        userTypeId: data?.userTypeId,
        isViewMode: true,
      },
    });
  };

  const handleCreateClick = () => {
    navigate("/user/register");
  };

  const handleViewList = async (data) => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${ifacSecurityURL}/api/GraphUserdetails/GetUserHospitalDetails/${data.userId}`,
        config
      );
      setUsername(data.userName);
      setViewlistopenDialog(true);
      setListRowData(response.data);


    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDelete = (data) => {
    setOpenDeleteDialog(true);
    setData(data);
  };

  const handleConfirmDelete = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.delete(
        `${ifacSecurityURL}/api/admin/Users/${data.login}`,
        config
      );

      if (response.status === 204) {
        toggleDeleteModal(false)();
        setOpenDialog(true);
        setContentDialog(dialogContent.deleted);
        fetchData();
      }
    } catch (error) {
      if (error.response.status === 400) {
        toggleDeleteModal(false)();
        setOpenDialog(true);
        setContentDialog(error.response.data.detail);
      }
      return error.response;
    }
  };

  const toggleDeleteModal = (newOpen) => () => {
    setOpenDeleteDialog(newOpen);
  };

  const handleDialogClose = () => {
    setOpenDeleteDialog(false);
    setOpenDialog(false);
  };

  const handleClick = () => {
    setViewlistopenDialog(false)
    setListRowData([]);
  };





  return (
    <>
      <PageTitle title={"User Registration"} />
      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={"User Registration List"} />

          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <CreateNewBtn
              onClick={handleCreateClick}
              link={"/userRegister/create"}
            />
            <RefreshExportButtons
              exportFunction={() => { }}
              exportData={rowData}
              refData={gridApi}
              handleRefresh={fetchData}
              title={`User Registration`}
            />
          </Stack>
        </Stack>
        <Box>
          <CustomAgGrid
            rows={rowData}
            columns={colDefs}
            ref={gridApi}
            setGridApi={setGridApi}
            // handleEdit={handleEdit}
            // handleView={handleView}
            // handleDelete={handleDelete}
            isLoading={isLoading}
          />
        </Box>
        <CustomDialog
          open={openDeleteDialog}
          onConfirm={handleConfirmDelete}
          content={dialogContent.confirmDelete}
          cancelBtn={"No"}
          confirmBtn={"Yes"}
          onClose={handleDialogClose}
        />
        <CustomDialog
          open={openDialog}
          content={contentDialog}
          confirmBtn={"Ok"}
          onConfirm={handleDialogClose}
        />
        <Dialog
          open={ViewlistopenDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return; // Prevent closing on backdrop click
            }
            setViewlistopenDialog(false); // Call the close function for other reasons
          }}
          confirmBtn={"Ok"}
          onConfirm={() => setViewlistopenDialog(false)}
          PaperProps={{
            sx: {
              width: '60% !important',
              maxWidth: 'none',     // prevent MUI from limiting the width
            }
          }}
          alignItems={"center"}
        >
          <Stack
            mb={1}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <SectionTitle />

            <Stack direction={"row"} alignItems={"center"} gap={1}>

              <RefreshExportButtons
                exportFunction={() => { }}
                exportData={listrowData}
                refData={gridApiHospitalList}
                handleRefresh={handleViewList}
                title={`${username} - Hospital List`}
              />
            </Stack>
          </Stack>
          <Box sx={{ height: 'auto', width: '100%' }}>
 
            <CustomAgGrid
              rows={listrowData}
              columns={colHospitalListDefs}
              ref={gridApiHospitalList}
              setGridApi={setGridApiHospitalList}
              isLoading={isLoading}
            />
          </Box>
          <Box>
            <Stack my={3} direction={"row"} justifyContent={"end"}>
              <Button variant="outlined" onClick={handleClick}>
                Close
              </Button>
            </Stack>
          </Box>
        </Dialog>
      </DefaultCard>
      <CloseButton />
    </>
  );
};

export default List;
